import {
    selectWatching,
    unsubscribeToMap,
    selectSubscribers,
    publishState,
} from "features/pubsub/slice"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { useEffect, useMemo } from "react"
import { getColorFromId } from "@nova/util-strings"
import { zIndex } from "@nova/constants"
import { selectActivatedFireId } from "features/map/control/selectors"
import { useRouter } from "pages"
import { useLocation } from "react-router"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"

export const PubsubPanel = () => {
    const watching = useAppSelector(selectWatching())
    const dispatch = useAppDispatch()
    const location = useLocation()
    const router = useRouter("/")
    const workspaceId = useAppSelector(selectActiveWorkspaceId()) || ""
    const projectId = useAppSelector(selectActivatedFireId) || ""
    const isInProject =
        router.preview({
            path: "/workspace/:workspaceId/project/:projectId",
            params: { workspaceId, projectId },
        }) === location.pathname
    const subscribers = useAppSelector(selectSubscribers())
    const hasSubscribers = useMemo(() => subscribers.length > 0, [subscribers])

    useEffect(() => {
        if (isInProject && hasSubscribers) {
            const interval = setInterval(() => dispatch(publishState(undefined)), 1000)
            return () => clearInterval(interval)
        }
    }, [hasSubscribers, dispatch, isInProject])

    if (!watching) return null
    return (
        <div
            onClick={() => dispatch(unsubscribeToMap())}
            className="absolute inset-0"
            style={{ zIndex: zIndex.PubsubPanel }}
        >
            <div
                className="absolute border-4 inset-0"
                style={{
                    borderColor: getColorFromId(watching.userId),
                    // height: `calc(100vh - ${navbarHeight}px - ${footerHeight}px)`,
                    // width: `100vw`,
                }}
            />
        </div>
    )
}

export default PubsubPanel
